import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const medicalDetailsValidationSchema = (status?: string) => {
  const isDisabled = status === 'CONFIRMED' || status === 'CANCELLED';

  return Yup.object({
    medicalDetails: Yup.object({
      medicalClassId: isDisabled ? Yup.string() : requiredText(),
      levelId: isDisabled ? Yup.string() : requiredText(),
      nssf: isDisabled ? Yup.string() : requiredText()
    })
  });
};
